import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AppCustomPreloader} from './app-routing-loader';
import {SessionGuard} from './data/auth/guards/session.guard';
import {CallCenterGuard} from './data/auth/guards/call-center.guard';
import {ColombiaGuard} from './data/auth/guards/colombia.guard';
import {SagGuard} from './data/auth/guards/sag.guard';
import {AnonymousGuard} from './data/auth/guards/anonymous.guard';
import { SupportGuard } from './data/auth/guards/support.guard';

const routes: Routes = [
  {
    path: 'producto/:id',
    loadChildren: () => import('./ui/product-detail/product-detail.module').then(m => m.ProductDetailModule),
  },
  /* {
    path: 'product/:id/:name',
    redirectTo: 'producto/:id',
  },
  {
    path: '#/product/:id/:name',
    redirectTo: 'producto/:id',
  },
  {
    path: 'product/:id',
    redirectTo: 'producto/:id',
  }, */
  {
    path: 'producto/:id/:name',
    redirectTo: 'producto/:id',
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./ui/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'buscar',
    pathMatch: 'full',
    loadChildren: () => import('./ui/algolia/algolia.module').then(m => m.AlgoliaModule),
  },
  {
    path: 'carrito',
    pathMatch: 'full',
    loadChildren: () => import('./ui/cart/cart.module').then(m => m.CartModule),
  },
  {
    path: 'sitemap',
    pathMatch: 'full',
    loadChildren: () => import('./ui/site-map/site-map.module').then(m => m.SiteMapModule)
  },
  {
    path: 'sitemap-colecciones',
    pathMatch: 'full',
    loadChildren: () => import('./ui/sitemap-collection/sitemap-collection.module').then(m => m.SitemapCollectionModule),
  },
  {
    path: 'checkout',
    loadChildren: () => import('./ui/checkout/checkout.module').then(m => m.CheckoutModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'catalogo',
    pathMatch: 'full',
    loadChildren: () => import('./ui/catalogo/catalogo.module').then(m => m.CatalogoModule),
  },
  {
    path: 'envialo-ya',
    pathMatch: 'full',
    loadChildren: () => import('./ui/envialo-ya/envialo-ya.module').then(m => m.EnvialoYaModule),
  },
  {
    path: 'legal/:page',
    pathMatch: 'full',
    loadChildren: () => import('./ui/legal/legal.module').then(m => m.LegalModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'politicas-de-devolucion',
    pathMatch: 'full',
    loadChildren: () => import('./ui/return-policy/return-policy.module').then(m => m.ReturnPolicyModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'terminos-y-condiciones',
    pathMatch: 'full',
    loadChildren: () => import('./ui/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'politicas/:politic',
    pathMatch: 'full',
    loadChildren: () => import('./ui/politics/politics.module').then(m => m.TermsConditionsModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'registro',
    pathMatch: 'full',
    loadChildren: () => import('./ui/session/session.module').then(m => m.SessionModule),
  },
  {
    path: 'registro-manual',
    pathMatch: 'full',
    loadChildren: () => import('./ui/session/session.module').then(m => m.SessionModule),
  },
  {
    path: 'departamentos',
    pathMatch: 'full',
    loadChildren: () => import('./ui/departments-responsive/departments-responsive.module')
      .then(m => m.DepartmentsResponsiveModule),
  },
  {
    path: 'mundo-ofertas',
    loadChildren: () => import('./ui/world-offers/world-offers.module').then(m => m.WorldOffersModule),
  },
  {
    path: 'mundoOfertas',
    loadChildren: () => import('./ui/world-offers/world-offers.module').then(m => m.WorldOffersModule),
    canActivate: [ColombiaGuard],
  },
  {
    path: 'programate-y-ahorra',
    loadChildren: () => import('./ui/program-and-save/program-and-save.module').then(m => m.ProgramAndSaveModule),
    canActivate: [ColombiaGuard],
  },
  {
    path: 'escanea-y-listo',
    loadChildren: () => import('./ui/scan-and-go/scan-and-go.module').then(m => m.ScanAndGoModule),
    canActivate: [SagGuard],
  },
  {
    path: 'mundo-ofertas/:idGroup',
    loadChildren: () => import('./ui/group-detail/group-detail.module').then(m => m.GroupDetailModule),
  },
  {
    path: 'marca/:nameBrand',
    loadChildren: () => import('./ui/brand/brand.module').then(m => m.BrandModule),
  },
  {
    path: 'marcas/:brand',
    loadChildren: () => import('./ui/provider-landing/provider-landing.module').then(m => m.ProviderLandingModule),
  },
  {
    path: 'marcas',
    loadChildren: () => import('./ui/provider-general/provider-general.module').then(m => m.ProviderGeneralModule),
  },
  {
    path: 'prime',
    loadChildren: () => import('./ui/prime/prime.module').then(m => m.PrimeModule),
  },
  {
    path: 'spotscan',
    loadChildren: () => import('./ui/spot-scan/spot-scan.module').then(m => m.SpotScanModule),
  },
  {
    path: 'sugeridos/:idGroup',
    loadChildren: () => import('./ui/group-detail/group-detail.module').then(m => m.GroupDetailModule),
  },
  {
    path: 'destacados/:idGroup',
    loadChildren: () => import('./ui/group-detail/group-detail.module').then(m => m.GroupDetailModule),
  },
  {
    path: 'categorias/:deparment',
    loadChildren: () => import('./ui/categories/categories.module').then(m => m.CategoriesModule),
  },
  {
    path: 'categorias/:deparment/:categorie',
    loadChildren: () => import('./ui/categories/categories.module').then(m => m.CategoriesModule),
  },
  {
    path: 'categorias/:deparment/:categorie/:subCategorie',
    loadChildren: () => import('./ui/categories/categories.module').then(m => m.CategoriesModule),
  },
  {
    path: 'ordenes',
    loadChildren: () => import('./ui/orders/orders.module').then(m => m.OrdersModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'detalle-orden/:id',
    loadChildren: () => import('./ui/order-detail/order-detail.module').then(m => m.OrderDetailModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'calificar/:id',
    loadChildren: () => import('./ui/qualify-order/qualify-order.module').then(m => m.QualifyOrderModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'error',
    pathMatch: 'full',
    loadChildren: () => import('./ui/error/error.module').then(m => m.ErrorModule),
  },
  {
    path: 'redime-tu-cupon',
    loadChildren: () => import('./ui/cupon/cupon.module').then(m => m.CuponModule),
  },
  {
    path: 'tiendas',
    loadChildren: () => import('./ui/locate-store/locate-store.module').then(m => m.LocateStoreModule),
  },
  {
    path: 'cuenta',
    loadChildren: () => import('./ui/customer-profile/customer-profile.module').then(m => m.CustomerProfileModule),
  },
  {
    path: 'lifemiles',
    loadChildren: () => import('./ui/life-miles-page/life-miles-page.module').then(m => m.LifeMilesPageModule),
    canActivate: [SessionGuard, ColombiaGuard],
  },
  {
    path: '404',
    loadChildren: () => import('./ui/not-found/not-found.module').then(m => m.NotFoundModule),
  },
  {
    path: 'call-center',
    loadChildren: () => import('./ui/call-center/call-center.module').then(m => m.CallCenterModule),
    canActivate: [CallCenterGuard, ColombiaGuard],
  },
  {
    path: 'producto/:id',
    loadChildren: () => import('./ui/product-detail/product-detail.module').then(m => m.ProductDetailModule),
  },
  {
    path: 'covid',
    loadChildren: () => import('./ui/covid/covid.module').then(m => m.CovidModule),
  },
  {
    path: 'tutorial/:id',
    loadChildren: () => import('./ui/shared/modules/tutorials/tutorials.module').then(m => m.TutorialsModule),
  },
  {
    path: 'mobile',
    loadChildren: () => import('./ui/customer-profile/zendesk-support/zendesk-support.module').then(m => m.ZendeskSupportModule),
  },
  {
    path: 'content/:tag',
    loadChildren: () => import('./ui/content/content.module').then(m => m.ContentModule),
  },
  {
    path: 'pill-reminder',
    loadChildren: () => import('./ui/modals/take-pill-modal/take-pill-modal.module').then(m => m.TakePillModalModule),
  },
  {
    path: 'pill-reminder-alert',
    loadChildren: () => import('./ui/modals/item-quantity-alert/item-quantity-alert.module').then(m => m.ItemQuantityAlertModule),
  },
  {
    path: 'pharmacovigilance/register/:subsidiary',
    loadChildren: () => import('./ui/uma-register/uma-register.module').then(m => m.UmaRegisterModule),
  },
  {
    path: 'pharmacovigilance',
    loadChildren: () => import('./ui/uma-select/uma-select.module').then(m => m.UmaSelectModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'pharmacovigilance/:select',
    loadChildren: () => import('./ui/uma-select/uma-select.module').then(m => m.UmaSelectModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'registro-express',
    loadChildren: () => import('./ui/registration-express/registration-express.module').then(m => m.RegistrationExpressModule),
    canActivate: [AnonymousGuard],
  },
  {
    path: 'finaliza-el-registro',
    loadChildren: () => import('./ui/express-store-registration/express-store-registration.module').then(m => m.ExpressStoreRegistrationModule),
    canActivate: [AnonymousGuard],
  },
  {
    path: 'empleo',
    loadChildren: () => import('./ui/job/job.module').then(m => m.JobModule),
  },
  {
    path: 'kustomer/open-chat',
    loadChildren: () => import('./ui/home/home.module').then(m => m.HomeModule),
    canActivate: [SupportGuard],
  },
  {
    path: 'favoritos',
    loadChildren: () => import('./ui/landings/landings.module').then(m => m.LandingsModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'vuelve-a-comprarlo',
    loadChildren: () => import('./ui/landings/landings.module').then(m => m.LandingsModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'continua-donde-quedaste',
    loadChildren: () => import('./ui/landings/landings.module').then(m => m.LandingsModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'nuestros-recomendados',
    loadChildren: () => import('./ui/landings/landings.module').then(m => m.LandingsModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: () => import('./ui/not-found/not-found.module').then(m => m.NotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload',
    initialNavigation: 'enabled',
    preloadingStrategy: AppCustomPreloader,
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule],
  providers: [AppCustomPreloader],
})
export class AppRoutingModule { }
